import { ConflictError, UnauthorizedError } from "../errors/http_errors";
import { GameSet } from "../models/gameSet";

async function fetchData(input: RequestInfo, init?: RequestInit) {
  const response = await fetch(input, init);

  if (response.ok) {
    return response;
  } else {
    const errorBody = await response.json();
    const errorMessage = errorBody.error;
    if (response.status === 401) {
      throw new UnauthorizedError(errorMessage);
    } else if (response.status === 409) {
      throw new ConflictError(errorMessage);
    } else {
      throw Error(
        "Request failed with status: " +
          response.status +
          " message: " +
          errorMessage
      );
    }
  }
}

export async function fetchGameSets(): Promise<GameSet[]> {
  const response = await fetchData(
    `${process.env.REACT_APP_API_URL}/api/gameSets`,
    {
      method: "GET",
      credentials: "include",
    }
  );
  return response.json();
}

export interface GameSetInput {
  title: string;
  score: number;
}

export async function createGameSet(gameSet: GameSetInput): Promise<GameSet> {
  const response = fetchData(`${process.env.REACT_APP_API_URL}/api/gameSets`, {
    method: "POST",
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(gameSet),
  });
  return (await response).json();
}

export async function updateGameSet(
  gameSetId: string,
  gameSet: GameSetInput
): Promise<GameSet> {
  const response = await fetchData(
    `${process.env.REACT_APP_API_URL}/api/gameSets/${gameSetId}`,
    {
      method: "PATCH",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(gameSet),
    }
  );
  return (await response).json();
}

export async function deleteGameSet(gameSetId: string) {
  await fetchData(
    `${process.env.REACT_APP_API_URL}/api/gameSets/` + gameSetId,
    { method: "DELETE", credentials: "include" }
  );
}
